import { For } from 'solid-js'
import { m } from '~/paraglide/messages'
import { Collapsible } from './collapsible'

function Step(props: { n: number; text: string }) {
  return (
    <li class="flex items-center gap-2">
      <span class="flex size-5 shrink-0 items-center justify-center rounded-full bg-moss text-xs font-bold text-white">
        {props.n}
      </span>
      <span class="text-base font-bold leading-5 text-moss">{props.text}</span>
    </li>
  )
}

export function HowItWorks() {
  const steps = [
    m.invite_page_step_1(),
    m.invite_page_step_2(),
    m.invite_page_step_3(),
    m.invite_page_step_4(),
  ]
  return (
    <Collapsible title={m.how_it_works()}>
      <ol class="flex flex-col gap-6">
        <For each={steps}>{(text, i) => <Step n={i() + 1} text={text} />}</For>
      </ol>
    </Collapsible>
  )
}
